/**
 * Ids that name a role, not a device ('default', and Windows'
 * 'communications'). The browser resolves them itself, so they are never
 * demanded exactly.
 */
const ROLE_DEVICE_IDS = new Set(['default', 'communications']);
/**
 * Whether an id names a role rather than one physical device.
 *
 * @param {string} deviceId - A device id.
 * @returns {boolean}
 */
export function isRoleDeviceId(deviceId) {
    return ROLE_DEVICE_IDS.has(deviceId);
}
/**
 * Names a camera so the browser must open exactly that one.
 *
 * lib-jitsi-meet copies cameraDeviceId verbatim into video.deviceId. A bare
 * string there is only an ideal, and current desktop Chromium does not use an
 * ideal deviceId to choose the camera: it opens its own ranked or default
 * camera. On 2026-09-23 every room track was the browser's first camera, never
 * the one the user picked, while the portal previews (which pass {exact}) got
 * the right one. {exact} opens that camera or fails with
 * OverconstrainedError/NotFoundError, which callers must handle.
 *
 * @param {string|null|undefined} deviceId - A camera id.
 * @returns {CameraDeviceIdConstraint|undefined} Undefined when no camera is named.
 */
export function exactCameraDeviceId(deviceId) {
    if (!deviceId) {
        return undefined;
    }
    return isRoleDeviceId(deviceId) ? deviceId : { exact: deviceId };
}
